import { Typography } from "@mui/material";
import React, { useState } from "react";
import CandleChart from "./CandleChart";
import Popover from "@mui/material/Popover";

const getCandleChart = (id, ticker) => {
  return (
    <CandleChart
      key={id}
      title={ticker}
      width={400}
      height={200}
    ></CandleChart>
  );
};

const TableCell = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [show, setShow] = useState(false);

  const onRowEnter = (event) => {
    setAnchorEl(event.currentTarget);
    setShow(true);
  };

  const onRowLeave = (event) => {
    setAnchorEl(null);
    setShow(false);
  };
  return (
    <div>
      <Typography onMouseEnter={onRowEnter} variant="body2" >
        {props.ticker}
        <Popover
          id="simple-popup"
          open={show}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          // sx={{
          //   pointerEvents: "none",
          // }}
          onClose={onRowLeave}
        >
          {getCandleChart(props.id, props.ticker)}
        </Popover>
      </Typography>
    </div>
  );
};

export default TableCell;
